import {
    SimplePageContentWrapper,
    SimplePageLayout
} from '@flexinet/ui-components';

import {IndexPageHeader} from '../components/IndexPageHeader';
import {RecordsTable} from "../tables/RecordsTable.tsx";

// The IndexPage renders inside the Playbook EditPage at /playbooks/:id. The
// useParams() id is the playbookId and is consumed by RecordsTable / AddFormDrawer
// via useParams() lookup. No top-level sidebar or route entry is added for phases.
export const IndexPage = () => {

    return (
        <SimplePageLayout
            pageHeader={<IndexPageHeader/>}
        >
            <SimplePageContentWrapper>
                <RecordsTable/>
            </SimplePageContentWrapper>
        </SimplePageLayout>
    );
};
